import React from 'react';
import {
  Avatar,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
} from '@material-ui/core';
import { useStyles } from './styles';
import { CircularProgress } from '@chakra-ui/react';
import ControlledPagination from 'shared/component/ControledPagination';

const getMonthName = (dateStr) => {
  const date = new Date(dateStr);
  const month = date.toLocaleString('pt-BR', { month: 'long' });
  return month.charAt(0).toUpperCase() + month.slice(1); // Capitaliza
};
const TableHoursWeek = ({
  data,
  loading,
  page,
  perPage,
  onChangePage,
  dateStart,
  dateEnd,
  total,
}) => {
  const classes = useStyles();

  // Não precisa mais paginar localmente: já vem da API só a página atual
  // Então pagine a API usando page/perPage e mostre os dados que já estão paginados

  // Apenas renderize os dados diretamente
  if (loading) {
    return (
      <div className={classes.loadingContainer}>
        <CircularProgress />
      </div>
    );
  }

  if (!data || data.length === 0) {
    return <div className={classes.noData}>Sem dados de horas na semana</div>;
  }

  const previousMonth = getMonthName(dateStart);
  const currentMonth = getMonthName(dateEnd);

  const sameMonth =
    new Date(dateStart).getMonth() === new Date(dateEnd).getMonth() &&
    new Date(dateStart).getFullYear() === new Date(dateEnd).getFullYear();

  return (
    <Paper className={classes.container} elevation={0}>
      <Table>
        {/* cabeçalho */}
        <TableHead>
          <TableRow>
            <TableCell>Usuário</TableCell>
            <TableCell>Horas Semanais</TableCell>
            {sameMonth ? (
              <TableCell>Horas em {currentMonth}</TableCell>
            ) : (
              <>
                <TableCell>Horas em {previousMonth}</TableCell>
                <TableCell>Horas em {currentMonth}</TableCell>
              </>
            )}
            {sameMonth ? (
              <TableCell>Plantões em {currentMonth}</TableCell>
            ) : (
              <>
                <TableCell>Plantões em {previousMonth}</TableCell>
                <TableCell>Plantões em {currentMonth}</TableCell>
              </>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((user) => (
            <TableRow key={user.id} className={classes.row}>
              <TableCell>
                <div className={classes.userInfo}>
                  <Avatar
                    alt={user.name}
                    src={`https://sua-api.com/${user.image}`}
                    className={classes.avatar}
                  />
                  <Typography className={classes.name}>{user.name}</Typography>
                </div>
              </TableCell>
              <TableCell>{user.weekly_hours}</TableCell>
              {sameMonth ? (
                <TableCell>{user.current_month_hours}</TableCell>
              ) : (
                <>
                  <TableCell>{user.previous_month_hours}</TableCell>
                  <TableCell>{user.current_month_hours}</TableCell>
                </>
              )}
              {sameMonth ? (
                <TableCell>{user.current_month_shifts}</TableCell>
              ) : (
                <>
                  <TableCell>{user.previous_month_shifts}</TableCell>
                  <TableCell>{user.current_month_shifts}</TableCell>
                </>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <div className={classes.paginationWrapper}>
        <div className={classes.paginationLeft}>
          <ControlledPagination
            total={total}
            pageByProps={page}
            perPage={perPage}
            loading={loading}
            onChange={(newPage) => onChangePage(newPage)}
          />
        </div>
      </div>
    </Paper>
  );
};
export default TableHoursWeek;
